<template>
  <div class="idVertifyPage">
    <!-- 未认证的样式 -->
    <div v-if='!cert_status'>
      <div v-if="tab==0">
        <ul class='list'>
          <li v-if='three_switch==1' class='active'  @click='tab="normal"'>
          <!-- <li v-if='three_switch==1' class='active'  @click='cert_status=1'> -->
            <img src="~@/assets/img/personal_img/3.png" alt="">
            <div>
              <h4>姓名+身份证+手机号认证<span>推荐</span></h4>
              <p>1.填写姓名、身份证号、手机号</p>
              <p>2.确保信息无误后提交、即可认证成功</p>
            </div>
            <span>立即实名</span>
          </li>
          <li v-if='ali_switch==1' @click='tab="ali"'>
            <img src="~@/assets/img/personal_img/1.png" alt="">
            <div>
              <h4>支付宝人脸识别认证</h4>
              <p>1.填写姓名、身份证号<span style='color:red' class="extra">(需要与支付宝绑定的信息一致)</span></p>
              <p>2.用支付宝APP扫描二维码、根据提示进行人脸识别认证</p>
            </div>
            <span>立即实名</span>
          </li>      
          <li v-if='weixin_switch==1' @click='tab="weixin"'>
            <img src="~@/assets/img/personal_img/2.png" alt="">
            <div>
              <h4>微信扫一扫实名认证</h4>
              <p>1.填写姓名、身份证号<span style='color:red' class="extra">(需要微信授权后再进行认证)</span></p>
              <p>2.用微信APP扫描二维码、根据提示进行人脸识别认证</p>
            </div>
            <span>立即实名</span>
          </li>      
        </ul>
        <div class='desc'>
            <h4>温馨提示</h4>
            <p>尊敬的客户，您好：《中华人民共和国网络安全法》第二十四条规定：</p>
            <p>网络运营者为用户办理网络接入、域名注册服务，办理固定电话、 移动电话等入网手续，或者为用户提供信息发布、即时通讯等服务。</p>
            <p>在与用户签订协议或者确认提供服务时，应当要求用户提供真实身份信息。用户不提供真实身份信息的，网络运营者不得为其提供相关服务。</p>
        </div>
      </div>
      <!-- 支付宝 微信 -->
      <div v-if='(tab=="ali"||tab=="weixin")&&!scanPageFlag'>
        <div class="top">
          <span class='active'>填写信息</span>
          <span>刷脸认证</span>
          <span>认证成功</span>
        </div>
        
        <Form :model="faceData" :label-width="80" class="myForm" >
          <FormItem label='姓名'>
            <Input v-model="faceData.cert_name" placeholder="请输入真实姓名"></Input>
          </FormItem>        
          <FormItem label='身份证号'>
            <Input v-model="faceData.cert_no" placeholder="请输入身份证号"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="faceVertify" class="submit">下一步</Button>
            <Button @click="tab=0;faceData={}" class='submit scanReturn' style='background-color:#aaa;margin:20px auto;color:#fff'>返回上一步</Button>
          </FormItem>
        </Form>

        <div class='desc'>
          <h4>温馨提示</h4>
          <p>1.请输入姓名、身份证号，输入信息后点击下一步。</p>
          <p v-if='tab=="ali"'>2.打开支付宝APP，扫描二维码，根据提示进行认证。</p>
          <p v-if='tab=="weixin"'>2.打开微信APP，扫描二维码，根据提示进行认证。</p>          
          <p v-if='tab=="ali"'>3.填写的信息需要与支付宝绑定的信息一致。</p>
          <p v-if='tab=="weixin"'>3.需要微信授权后再进行认证</p>
        </div>
      </div>       
      <!-- 三要素认证 -->
      <div v-show='tab=="normal"&&!scanPageFlag'>
        <Form :model="formData" :label-width="80" class="myForm" >
          <FormItem label="身份证姓名">
            <Input v-model="formData.name" placeholder="请输入姓名"></Input>
          </FormItem>
          <FormItem label="身份证号">
            <Input v-model="formData.idcard" placeholder="请输入身份证号码"></Input>
          </FormItem>
          <FormItem label="手机号">
            <Input v-model="formData.mobile" placeholder="请输入以上实名手机号" @input="mobileChange"></Input>
          </FormItem>
          <FormItem v-show="codeFlag" label="获取验证码">
            <Captcha :mobile="formData.mobile" ></Captcha>
          </FormItem>
          <FormItem label="验证码">
            <Input v-model="formData.code"></Input>
          </FormItem>
          <FormItem label="验证接口">
            <RadioGroup v-model="formData.type">
              <Radio label="ty">认证方式一</Radio>
              <Radio label="sjb">认证方式二</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="submitVertify" class="submit">提交</Button>
            <Button @click="tab=0;formData={'type':'ty'}" class="submit scanReturn" style='background-color:#aaa;color:#fff;margin:20px auto;display:block'>返回上一步</Button>
          </FormItem>
        </Form>
      </div>

      <!-- 扫码认证页面 -->
      <div v-if='scanPageFlag' class='scanPage'>
        <div class="top active">
          <span class='active'>填写信息</span>
          <span class='active'>刷脸认证</span>
          <span>认证成功</span>
        </div>
        <div class="content">
          <img class='img' :src='ewmSrc'>
          <p v-if='tab=="ali"'><i></i>支付宝扫码认证</p>
          <p v-if='tab=="weixin"'><i class='weixin'></i>微信扫码认证</p>
        </div>
        <Button @click="goBack" class='scanReturn' style='width:230px; background-color:#aaa;color:#fff;margin:0 auto;display:block'>返回上一步</Button>
        <div class='desc'>
          <h4>温馨提示</h4>
          <p>1.请输入姓名、身份证号，输入信息后点击下一步。</p>
          <p v-if='tab=="ali"'>2.打开支付宝APP，扫描二维码，进行认证</p>
          <p v-if='tab=="weixin"'>2.打开微信APP，扫描二维码，进行认证</p>
          <p v-if='tab=="ali"'>3.填写的信息需要与支付宝绑定的信息一致</p>
          <p v-if='tab=="weixin"'>3.需要微信授权后再进行认证</p>
        </div>
      </div>
    </div>

    <!-- 认证成功的样式 -->
    <div v-if="cert_status" class="hadVertify">
      <img style='margin:20px auto -8px' src="~@/assets/img/personal_img/success.png" alt="">
      认证成功!<br>
      您已获得免费时长奖励
    </div>
  </div>
</template>

<script src="https://g.alicdn.com/AWSC/AWSC/awsc.js"></script>
<script>
import doPost from "@/pages/Helper/XHR.js";
import axios from "axios"
import Captcha from "@/pages/Personal/components/Captcha.vue"
export default {
  data() {
    return {
      formData: {
        type: "ty", //设定默认的认证方式
        mobile: "",//默认不填入
      },
      faceData:{},
      cert_status: "", //用户是否实名认证
      nowTime: 0,
      ewmSrc:"",
      timer:"",
      tab:0,
      scanPageFlag:false,
      ali_switch:1,
      weixin_switch:1,
      three_switch:1,
      codeFlag:false,
    };
  },
  components:{
    Captcha,
  },
  created() {
    //是否展示全部认证方式
    if(localStorage.getItem("ali_switch")){
      this.ali_switch=localStorage.getItem("ali_switch")
      this.weixin_switch=localStorage.getItem("weixin_switch")
      this.three_switch=localStorage.getItem("three_switch")
    }
    
    //获取用户的手机
    if (localStorage.getItem("username")) {
      // this.formData.mobile = localStorage.getItem("username")
      //   ? localStorage.getItem("username")
      //   : "";
      this.cert_status = localStorage.getItem("cert_status")
        ? localStorage.getItem("cert_status")
        : "";        
    } else {
      this.$Message.error("请先登录后，再进行实名验证");
      setTimeout(function() {
        this.$emit("loginout");
      }, 1500);
    }
    console.log('cert_status===='+this.cert_status);
    
  },
  beforeDestroy(){
    if(this.timer){
      clearInterval(this.timer)
      this.timer=""
    }
  },
  methods: {
    //提交验证
    submitVertify() {
      let clcikTime = Date.now();
      let difference = clcikTime - this.nowTime;
      if (difference < 1000) {
        this.nowTime = Date.now();
        return;
      } else {
        this.nowTime = Date.now();
      }
      if (!this.formData.name || !this.formData.idcard) {
        this.$Message.error("请正确填入身份证以及姓名，进行实名验证");
        return;
      }

      doPost(
        {
          //idcard_check 这个接口是请求到天眼认证      idcard_check_bak这个接口是请求到数据宝
          action:this.formData.type == "ty" ? "idcard_check" : "idcard_check_bak",
          name: this.formData.name ? this.formData.name : "",
          idcard: this.formData.idcard ? this.formData.idcard : "",
          mobile: this.formData.mobile ? this.formData.mobile : "",
          code: this.formData.code ? this.formData.code : "",
          session: localStorage.getItem("session"),
          web: "pc"
        },
        data => {
          if (data.status == 0) {
            this.$Message.success(data.detail);
            this.cert_status = "1";
            localStorage.setItem("cert_status", "1");
          } else {
            this.$Message.error(data.detail);
          }
        }
      );
    },
    //人脸识别   下一步
    faceVertify(){
      if (!this.faceData.cert_name || !this.faceData.cert_no) {
        this.$Message.error("请正确填入身份证以及姓名，进行实名验证");
        return;
      }
      if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.faceData.cert_no)==false){
         this.$Message.error("身份证不合法");
         return
      }
      let obj={}
      if(this.tab=='ali'){
        obj={
          action:"face_recognition",
          cert_name:this.faceData.cert_name,
          cert_no:this.faceData.cert_no,
          session:localStorage.getItem("session"),
        }
      }else if(this.tab=='weixin'){
        obj={
          action:"get_face_id",
          Name:this.faceData.cert_name,
          IdCard:this.faceData.cert_no,
          session:localStorage.getItem("session"),
        }
      }
      doPost(
        obj,
        (res)=>{
          if(res.status==0){
            this.ewmSrc=res.detail.code_url
            this.scanPageFlag=true;

            //上面是去获取二维码，下面是去查询结果
            this.timer=setInterval(() => {
              if(this.tab=='ali'){
                this.query()
              }else if(this.tab=='weixin'){
                this.query(res.detail.EidToken)
              }
            }, 3000);
          }else{
            this.$Message.error(res.detail)
          }
      })
    },
    //结果查询
    query(val){
        let obj={};
        if(this.tab=='ali'){
          obj={
            action:"face_result",
            session: localStorage.getItem("session"),
            product:"HS"
          }
        }else if(this.tab=='weixin'){
          obj={
            action:'get_wx_face_result',
            EidToken:val,
            session:localStorage.getItem("session")
          }
        }
        doPost(
          obj,
          (res)=>{
            if(res.status==0){
              clearInterval(this.timer)
              this.timer=''
              this.cert_status='1'
              localStorage.setItem("cert_status", "1");
            }else if(res.status==1&&this.tab=='weixin'){
              //认证失败 跳到上一步 同时取消轮询
              clearInterval(this.timer)
              this.timer=''
              this.scanPageFlag=false
            }
          }
        )

    },

    // 扫码页面的 返回上一步
    goBack(){
      this.scanPageFlag=false;
      if(this.timer){
        clearInterval(this.timer)
        this.timer=""
      }
    },
    mobileChange(val){
      if(val.length==11){
        this.codeFlag = true
      }else{
        this.codeFlag =false
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.myForm {
  width: 450px;
  margin: 20px 0 0 206px;
  >>>.ivu-input {
     background-color #f7f7f7
  }
  >>>.ivu-input.scanReturn:hover {
    border-color transparent
  }
}

.submit {
  width: 100%;
}
.scanReturn {
  margin-bottom 20px!important
  &:hover {
    border-color transparent
  }
}
.hadVertify {
  margin-top: 80px;
  text-align: center;
  font-size: 36px;
  line-height 44px
}
.ewmPage {
  position relative
}
.goBack  {
  text-align center
  cursor pointer
}
p {
  text-emphasis left
  line-height 22px
  margin-bottom 10px
}
img {
  display block
  margin 20px auto
}
.list {
  padding 15px
}
.list li{
  display flex
  justify-content space-around
  align-items center
  width 650px
  padding 5px 20px
  margin 15px auto
  font-weight bold
  position relative
  box-shadow 0 0 10px 1px #eee
  &.active {
    background-color #EDF9FF

  }
  &:hover {
    cursor  pointer
    transform scale(1.05)
  }
  div {
    flex 1
    width 300px
    min-height 65px
    margin-left 25px
    h4 {
      color #333
      font-size 18px
      margin-bottom 10px
      span {
        display inline-block
        padding 5px 10px
        background-color #f53d59
        color #fff
        margin-left 10px
        border-radius 5px
      }
    }
    p {
      font-size 12px
      color #7f7f7f
      line-height 22px
      margin-bottom 0px
      font-weight normal
    }
  }
  span {
    cursor pointer
    // color #dd1b33
    color #1181FF
  }
}
.desc {
  h4 {
    color red
    font-size 16px
    margin-bottom 15px
  }
  p {
    color #7f7f7f
    margin-bottom 5px
  }
} 
.top {
  width 340px
  height 54px
  margin 20px auto
  display flex
  justify-content space-between
  position relative
  &.active::after {
    content ""
    width 140px
    height 6px
    background-color #02a7f0   
    position absolute
    top 10px
    left  20px
  }
  &::before {
    content ""
    width 300px
    height 6px
    background-color #f2f2f2   
    position absolute
    top 10px
    left  20px

  }
  span {
    display inline-block
    width 60px
    margin-bottom 20px
    position relative
    z-index 10
    color #aaa
    &::before {
      display block
      margin 0 auto 10px
      content:'1'
      width 30px
      height 30px
      background-color #aaa
      color #fff
      border-radius 50%
      line-height 30px
      text-align center
    }
    &:nth-child(2)::before {
      content '2'
    }    
    &:nth-child(3)::before {
      content '3'
    }
  }

  span.active {
    color #02a7f0
    &::before {
      background-color #02a7f0
    }
  }
}

.scanPage {
  .content {
    .img {
      display block
      width 150px
      height 150px
      margin 20px auto
    }
    p {
      text-indent 75px
      position relative
      i {
        position absolute
        width 25px 
        height 25px
        top -3px
        left 41px
        background url('~@/assets/img/personal_img/1.png') no-repeat 0 0/25px 25px
        &.weixin {
          background-image url('~@/assets/img/personal_img/2.png')
        }
      }
    }
    margin 30px auto
    overflow hidden
    width 220px
    height 220px
    border-radius 5px
    box-shadow 0 0 5px #ccc
  }
}
@media screen and (max-width: 768px) {
  .myForm {
    width: 100%;
    margin 20px auto
  }

  .hadVertify {
    font-size: 22px;
  }
  .list li {
    width 100%
    height auto
    padding 10px 0
    img {
      width 40px
    }
    div {
      margin-left 10px
      h4 {
        font-size 14px
      }
      p {
        font-size 12px
      }
    }
    span {
      font-size 12px
      position absolute
      right 10px

    }
  }
  .scanReturn {
    width 100%
  }
  .list li span.extra {
    position static
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Personal/components/idVertify.vue